/*
 * View for categories
 */

define(["marionette", "./template/categoryListTemplate.html"], function (
  Marionette,
  CategoryListTemplate,
) {
  var CategoryListView = {};

  CategoryListView.categoryListLayout = Marionette.Layout.extend({
    template: CategoryListTemplate,
    regions: {
      list: "#list",
    },
  });

  return CategoryListView;
});
